import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function ContentCard({ card, i }) {
    const [hovered, setHovered] = useState(false);

    return (
        <Link to={card.href} className="w-full sm:w-[45%] lg:w-[30%]">
            <motion.div
                className="bg-[#9eeed2] rounded-xl shadow-lg p-4 flex flex-row md:flex-col items-center gap-4 transition-transform hover:scale-[1.02] h-full"
                style={{ minHeight: "80px" }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                {/* 画像 */}
                <div className="relative w-24 h-24 sm:w-28 sm:h-28 md:w-full md:h-36 flex-shrink-0 rounded-lg overflow-hidden">
                    <img
                        src={card.image}
                        alt={card.title}
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                </div>

                {/* テキスト */}
                <div className="flex-1 flex flex-col justify-center text-left md:text-center">
                    <h3 className="text-base sm:text-lg font-semibold mb-1">{card.title}</h3>
                    <p className="text-gray-700 text-xs sm:text-sm">{card.desc}</p>
                </div>
            </motion.div>
        </Link>
    );
}

export default function ContentCards({ cards = [] }) {
    if (cards.length === 0)
        return <p className="text-center text-black-500">コンテンツがありません。</p>;

    return (
        <div className="w-full flex justify-center">
            <div className="flex flex-wrap justify-center gap-4 md:gap-5 max-w-5xl w-full px-4">
                {cards.map((card, i) => (
                    <ContentCard key={i} card={card} i={i} />
                ))}
            </div>
        </div>
    );
}
